/* Palsora cart drawer: opens from the cart icon and after any add to cart; uses Shopify's /cart AJAX endpoints. */
(function () {
  if (window.PalsCart) return;

  var offersEl, root, panel, list, empty, foot, err, shipBox, shipMsg, shipLine, bar, countEl, subEl, discBox, discAmt;
  var cfg = { money: '${{amount}}', threshold: 0, cartUrl: '/cart' };
  var lastFocus = null, busy = false;
  var onCartPage = function () { return /\/cart\/?$/.test(window.location.pathname); };

  function money(cents) {
    return cfg.money.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      var n = cents / 100;
      var s = k.indexOf('no_decimals') > -1 ? String(Math.round(n)) : n.toFixed(2);
      var comma = k.indexOf('comma') > -1;
      var p = s.split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, comma ? '.' : ',');
      return p.join(comma ? ',' : '.');
    });
  }  function moneyR(cents) { return money(Math.round(cents / 100) * 100).replace(/([.,])00(?!\d)/, ''); }

  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function sized(url, w) { if (!url) return ''; return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }

  function setCount(n) {
    document.querySelectorAll('[data-pals-cart-count], #cart-icon-bubble .pals-header__count').forEach(function (el) {
      var changed = el.textContent !== String(n);
      el.textContent = n;
      el.hidden = n === 0;
      if (changed && n > 0) { el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump'); }
    });
  }


  // ---- bundles: config from snippets/palsora-cart-drawer (#PalsBundleCfg) ----
  // Bundles are normal products + automatic discounts. Here we only group the lines a discount joined
  // together, and suggest the next bundle. Percentages come from the config and must match the discounts.
  var BCFG = null;
  function bcfg() {
    if (BCFG !== null) return BCFG;
    try { BCFG = JSON.parse(document.getElementById('PalsBundleCfg').textContent); } catch (e) { BCFG = false; }
    return BCFG;
  }
  function off(c, pct) { return Math.round(c * (100 - pct) / 100); }
  function disc(it) { return it.final_line_price < it.original_line_price; }
  function qty(list) { return list.reduce(function (n, it) { return n + it.quantity; }, 0); }
  function analyse(cart) {
    var c = bcfg();
    if (!c || !cart) return null;
    var a = { c: c, F: [], C: [], W: [], X: [], D: [], groups: [], byLine: {} };
    cart.items.forEach(function (it, i) {
      it._line = i + 1;
      if (it.product_id === c.fountain) a.F.push(it);
      else if (it.product_id === c.filters) a.X.push(it);
      else if (c.feeder && it.product_id === c.feeder) a.D.push(it);
    });
    function groupOf(it) { return a.byLine[it._line] || null; }
    function join(g, it) { if (g.lines.indexOf(it) < 0) g.lines.push(it); a.byLine[it._line] = g; }
    function make(title, lines) { var g = { titles: [title], lines: [] }; a.groups.push(g); lines.forEach(function (it) { join(g, it); }); return g; }
    function attach(title, buy, get) {
      var g = groupOf(buy) || groupOf(get);
      if (!g) { make(title, [buy, get]); return; }
      g.titles.push(title); join(g, buy); join(g, get);
    }
    /* bundle deals (pair, fountain + filters, feed & water set) are switched off, so no lines are grouped */
    a.groups.forEach(function (g) {
      g.lines.sort(function (x, y) { return x._line - y._line; });
      g.save = g.lines.reduce(function (n, it) {
        var was = it.original_line_price, spa = it.selling_plan_allocation;
        if (spa && spa.compare_at_price) was = Math.max(was, spa.compare_at_price * it.quantity);
        return n + (was - it.final_line_price);
      }, 0);
      g.title = 'Bundle: ' + g.titles.join(' + ');
    });
    a.groups = a.groups.filter(function (g) { return g.save > 0; });
    a.byLine = {};
    a.groups.forEach(function (g) { g.lines.forEach(function (it) { a.byLine[it._line] = g; }); });
    return a;
  }
  function styleOf(it) { return ((it.options_with_values || [])[0] || {}).value || ''; }
  function noteText() { return ''; }
  // Shopify lets one fountain unlock one bundle deal (a buy-X-get-Y item can't also carry another
  // discount), so only offer the next fountain deal when none is active yet, and only one at a time.
  function offers(a) {
    var out = [];
    if (!a) return out;
    var c = a.c, f = a.F[0];
    /* bundle deals are switched off: the drawer only offers the filter subscription */
    // filter subscription: with a 3.2L fountain in the cart and no filters yet, offer it right under the filter bundle
    var fit = a.F.some(function (x) { return /3\.2L/i.test(x.variant_title || ''); });
    var fs = c.filterSub;
    if (fit && !a.X.length && fs && fs.available && fs.plans && fs.plans.length) {
      var at = 0;
      for (var i = 0; i < out.length; i++) if (out[i].variant === (c.filter6 && c.filter6.id)) at = i + 1;
      out.splice(at, 0, { kind: 'sub', variant: fs.id, img: fs.img, plans: fs.plans, pack: fs.pack });
    }
    return out;
  }
  function subHTML(o) {
    var best = Math.max.apply(null, o.plans.map(function (p) { return p.pct || 0; }));
    var rec = o.plans.filter(function (p) { return p.rec; })[0] || o.plans[0];
    // one-time purchase (no subscription) at the full price, listed first
    var full = o.plans.reduce(function (n, p) { return Math.max(n, p.was || 0); }, 0) || (o.full || 0);
    return '<div class="pals-bo pals-bo--sub" data-kind="sub">' +
      '<span class="pals-bo__pics" aria-hidden="true">' + (o.img ? '<img src="' + esc(o.img) + '" alt="" width="64" height="64" loading="lazy">' : '') + '</span>' +
      '<span class="pals-bo__body"><b class="pals-bo__t">' + (list_has_filter_offer ? 'Or subscribe' : 'Filters on subscription') + ' &amp; save ' + best + '%</b>' +
      '<span class="pals-bo__s">' + o.pack + ' filters + ' + o.pack + ' sponges sent automatically, so fresh filters arrive before you run out. The first pack ships with this order.</span></span>' +
      '<span class="pals-bo__plans" role="radiogroup" aria-label="How often">' +
        '<label class="pals-bo__plan"><input type="radio" name="pals-bo-sub" value="">' +
        '<span class="pals-bo__pl"><b>No subscription</b><small>One pack, full price</small></span>' +
        '<span class="pals-bo__pp"><b>' + esc(money(full)) + '</b></span></label>' + o.plans.map(function (p) {
        return '<label class="pals-bo__plan"><input type="radio" name="pals-bo-sub" value="' + p.id + '"' + (p === rec ? ' checked' : '') + '>' +
          '<span class="pals-bo__pl"><b>' + esc(p.label) + (p.rec && o.plans.length > 1 ? ' <i>Recommended</i>' : '') + '</b><small>' + esc(p.note) + '</small>' + (p.was > p.price ? '<em class="pals-bo__saved">You save ' + esc(money(p.was - p.price)) + '</em>' : '') + '</span>' +
          '<span class="pals-bo__pp"><b>' + esc(money(p.price)) + '</b>' + (p.was > p.price ? '<s>' + esc(money(p.was)) + '</s>' : '') + '</span></label>';
      }).join('') + '</span>' +
      '<a class="pals-bo__more" href="' + esc(o.url || '/products/fountain-replacement-filters') + '">View other offers</a>' +
      '<span class="pals-bo__fine" data-pals-sub-fine>Charged and sent automatically each delivery until you cancel. Each filter is best changed every 2–4 weeks.</span>' +
      '<button type="button" class="pals-bo__btn" data-pals-offer="sub" data-variant="' + o.variant + '">Subscribe</button>' +
      '</div>';
  }
  var list_has_filter_offer = false;
  function offersHTML(list) {
    if (!list.length) return '';
    list_has_filter_offer = list.some(function (o) { return o.kind === 'add' && /filters/i.test(o.title); });
    return '<p class="pals-bo__k">Save on filters</p>' + list.map(function (o) {
      if (o.kind === 'sub') return subHTML(o);
      return '<div class="pals-bo" data-kind="' + o.kind + '">' +
        '<span class="pals-bo__pics" aria-hidden="true">' + (o.img ? '<img src="' + esc(o.img) + '" alt="" width="64" height="64" loading="lazy">' : '') + '</span>' +
        '<span class="pals-bo__body"><b class="pals-bo__t">' + esc(o.title) + '</b><span class="pals-bo__s">' + esc(o.text) + '</span>' +
        '<span class="pals-bo__pr"><b>' + esc(money(o.price)) + '</b>' + (o.was > o.price ? '<s>' + esc(money(o.was)) + '</s>' : '') + (o.tag ? '<em>' + esc(o.tag) + '</em>' : '') + '</span></span>' +
        '<button type="button" class="pals-bo__btn" data-pals-offer="' + o.kind + '"' + (o.variant ? ' data-variant="' + o.variant + '"' : '') + (o.key ? ' data-key="' + esc(o.key) + '" data-q="' + o.q + '"' : '') + '>' + esc(o.btn) + '</button>' +
        '</div>';
    }).join('');
  }
  function post(url, data) {
    return fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(data) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw j; return j; }); });
  }
  function takeOffer(btn) {
    if (!btn) return Promise.resolve();
    btn.disabled = true; btn.setAttribute('aria-busy', 'true');
    var kind = btn.getAttribute('data-pals-offer'), job;
    if (kind === 'qty') job = post('/cart/change.js', { id: btn.getAttribute('data-key'), quantity: +btn.getAttribute('data-q') });
    else if (kind === 'sub') {
      var pick = btn.closest('.pals-bo').querySelector('input[name="pals-bo-sub"]:checked');
      job = post('/cart/add.js', { items: [{ id: +btn.getAttribute('data-variant'), quantity: 1, selling_plan: pick && pick.value ? +pick.value : undefined }] });
    }
    else job = post('/cart/add.js', { items: [{ id: +btn.getAttribute('data-variant'), quantity: 1 }] });
    return job.catch(function (e) { btn.disabled = false; btn.removeAttribute('aria-busy'); showErr((e && (e.description || e.message)) || 'Sorry, that could not be added. Please try again.'); throw e; });
  }
  function bundleNote() { return ''; }

  // ---- 5-year warranty offer (snippets/palsora-warranty-offer): one cover per fountain or feeder ----
  var WAR_TYPES = ['Water Fountains', 'Pet Feeders'], warSync = false;
  function warCounts(cart, vid) {
    var elig = 0, have = 0, key = null;
    cart.items.forEach(function (it) {
      if (WAR_TYPES.indexOf(it.product_type) > -1) elig += it.quantity;
      if (String(it.variant_id) === String(vid)) { have += it.quantity; key = it.key; }
    });
    return { elig: elig, have: have, key: key };
  }
  // Free-shipping nudge: when the cart is just under the free-shipping line and the 3-year warranty
  // would take it over (the warranty counts towards the free-shipping total), offer it in the shipping bar.
  function warNudge(cart, left) {
    var box = root && root.querySelector('[data-pals-cd-war]');
    if (!box) return '';
    var vid = box.getAttribute('data-variant'), price = +box.getAttribute('data-price') || 0, c = warCounts(cart, vid), need = c.elig - c.have;
    if (need < 1 || price <= 0 || price * need < left) return '';
    return '<button type="button" class="pals-cd__nudge" data-pals-war-nudge><span>Add the 3-year warranty for <b>' + esc(money(price * need)) + '</b> and your order ships free</span><em>Add</em></button>';
  }
  function renderWar(cart) {
    var box = root && root.querySelector('[data-pals-cd-war]');
    if (!box) return;
    var vid = box.getAttribute('data-variant'), price = +box.getAttribute('data-price') || 0;
    var c = warCounts(cart, vid), need = c.elig - c.have;
    if (c.have > c.elig && c.key && !warSync) {
      warSync = true;
      post('/cart/change.js', { id: c.key, quantity: c.elig }).then(function () { warSync = false; return load(); }).catch(function () { warSync = false; });
    }
    box.hidden = need <= 0;
    if (need <= 0) return;
    var p = box.querySelector('[data-pals-war-price]'), b = box.querySelector('[data-pals-war-add]');
    p.textContent = money(price) + (need > 1 ? ' each \u00b7 covers ' + need + ' items' : '');
    b.textContent = need > 1 ? 'Add for ' + money(price * need) : 'Add';
    b.setAttribute('data-need', need);
  }

  // ---- free gifts (automatic discounts "Free gift: cleaning kit with every fountain" and
  // "Free gift: feeding mat with every feeder"): one cleaning kit per fountain, one feeding mat per feeder ----
  var giftSync = false;
  var GIFTS = [{ attr: 'data-gift', type: 'Water Fountains', with: 'fountain' }, { attr: 'data-gift-feeder', type: 'Pet Feeders', with: 'feeder' }];
  function giftRoot() { return root || document.querySelector('[data-pals-cd]'); }
  function giftOf(vid) {
    var r = giftRoot(); if (!r) return null;
    for (var i = 0; i < GIFTS.length; i++) { var g = r.getAttribute(GIFTS[i].attr); if (g && String(vid) === g) return GIFTS[i]; }
    return null;
  }
  function giftNeed(cart) {
    var r = giftRoot(), out = null;
    if (!r) return null;
    GIFTS.forEach(function (G) {
      var gid = r.getAttribute(G.attr), n = 0, have = 0, key = null;
      if (!gid || out) return;
      cart.items.forEach(function (it) {
        if (it.product_type === G.type) n += it.quantity;
        if (String(it.variant_id) === gid) { have += it.quantity; key = it.key; }
      });
      if (n !== have) out = { gid: gid, n: n, key: key };
    });
    return out;
  }
  // Shopify lists the newest cart line first (in the cart and at checkout), so a missing free gift is added just
  // before its fountain or feeder. That keeps the product itself at the top, with its gift underneath.
  function giftFirst(fd) {
    var c = bcfg(), r = giftRoot(), pid = +fd.get('product-id'), gid = null;
    if (!c || !r || !pid) return Promise.resolve();
    if (pid === c.fountain) gid = r.getAttribute('data-gift');
    else if (c.feeder && pid === c.feeder) gid = r.getAttribute('data-gift-feeder');
    if (!gid) return Promise.resolve();
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (x) { return x.json(); })
      .then(function (cart) {
        if (cart.items.some(function (it) { return String(it.variant_id) === gid; })) return;
        return post('/cart/add.js', { items: [{ id: +gid, quantity: 1 }] });
      })
      .catch(function () {});
  }
  function fixGift(need) {
    return need.key ? post('/cart/change.js', { id: need.key, quantity: need.n }) : post('/cart/add.js', { items: [{ id: +need.gid, quantity: need.n }] });
  }
  function syncGift(cart) {
    var need = giftNeed(cart);
    if (!need || giftSync) return;
    giftSync = true;
    fixGift(need).then(function () { giftSync = false; return load(); }).catch(function () { giftSync = false; });
  }

  // gifts already part of every fountain (shown as included, not separate cart lines).
  // The values match the free gifts card in snippets/palsora-fountain-extras.liquid.
  var GIFT_INCL = [{ t: '1-Year Warranty', v: 1500 }, { t: 'Filter', v: 1000 }];
  var GIFT_INCL_FEEDER = [{ t: '1-Year Warranty', v: 1500 }];
  function inclHTML(it) {
    var gl = it.product_type === 'Water Fountains' ? GIFT_INCL : it.product_type === 'Pet Feeders' ? GIFT_INCL_FEEDER : null;
    if (!gl) return '';
    return '<ul class="pals-cd__incl" aria-label="Included free">' + gl.map(function (g) {
      return '<li><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5.5 12.5l4 4 9-9.5"/></svg><span>' + esc(g.t) + (it.quantity > 1 ? ' × ' + it.quantity : '') + '</span><s>' + esc(money(g.v * it.quantity)) + '</s><b>FREE</b></li>';
    }).join('') + '</ul>';
  }

  function render(cart) {
    setCount(cart.item_count);
    if (!root) return;
    countEl.textContent = cart.item_count ? '(' + cart.item_count + (cart.item_count === 1 ? ' item)' : ' items)') : '';
    var isEmpty = cart.item_count === 0;
    empty.hidden = !isEmpty;
    foot.hidden = isEmpty;
    if (shipBox) {
      var PS = window.PalsShip, cc = PS && PS.country(), z = PS && PS.zone(cc);
      shipBox.hidden = isEmpty || !z || !z.free;
      if (z) {
        var th = PS.cents(z.free), total = cart.total_price /* Shopify counts the whole order, including the warranty, towards free shipping (checked at checkout) */, left = z.free ? th - total : 1;
        if (z.free) {
        bar.style.width = Math.max(0, Math.min(100, (total / th) * 100)) + '%';
        bar.parentNode.setAttribute('aria-valuenow', Math.round(Math.min(100, (total / th) * 100)));
        shipMsg.innerHTML = left > 0
          ? 'You’re <b>' + esc(money(left)) + '</b> away from free tracked shipping to ' + esc(PS.to(cc))
          : '<b>You’ve unlocked free tracked shipping</b> to ' + esc(PS.to(cc));
        if (left > 0) shipMsg.innerHTML += warNudge(cart, left);
        }
        if (shipLine) {
          var light = cart.total_weight > 0 && cart.total_weight < 300;
          shipLine.innerHTML = 'Tracked shipping to ' + esc(PS.to(cc)) + ': <b>' + (left <= 0 ? 'Free' : esc(PS.fmt(light ? z.refill : z.price))) + '</b>. Any discount codes are applied at checkout.';
        }
      } else if (shipLine) {
        shipLine.textContent = 'Shipping and any discount codes are calculated at checkout.';
      }
    }
    subEl.textContent = money(cart.items_subtotal_price);
    renderWar(cart);
    syncGift(cart);
    // Savings = discounts plus the subscription price reduction, so it matches the struck-through prices
    var saved = cart.items.reduce(function (n, it) {
      var w = it.original_line_price, sp = it.selling_plan_allocation;
      if (sp && sp.compare_at_price) w = Math.max(w, sp.compare_at_price * it.quantity);
      return n + Math.max(0, w - it.final_line_price);
    }, 0);
    if (saved > 0) { discBox.hidden = false; discAmt.textContent = '−' + money(saved); } else { discBox.hidden = true; }
    var A = analyse(cart);
    function row(it, i) {
      var opts = (it.options_with_values || []).filter(function (o) { return o.value !== 'Default Title'; }).map(function (o) { return esc(o.value); }).join(' · ');
      var props = it.properties ? Object.keys(it.properties).filter(function (k) { return k.charAt(0) !== '_' && it.properties[k]; }).map(function (k) { return esc(k) + ': ' + esc(it.properties[k]); }).join('<br>') : '';
      var spa = it.selling_plan_allocation, wasC = it.original_line_price;
      if (spa && spa.compare_at_price) wasC = Math.max(wasC, spa.compare_at_price * it.quantity);
      var was = wasC > it.final_line_price ? '<s>' + esc(money(wasC)) + '</s>' : '';
      var gift = giftOf(it.variant_id);
      if (gift) {
        return '<div class="pals-cd__item pals-cd__item--gift" data-line="' + (i + 1) + '" data-key="' + esc(it.key) + '" data-qty="' + it.quantity + '">' +
          '<span class="pals-cd__img">' + (it.image ? '<img src="' + esc(sized(it.image, 200)) + '" alt="" width="84" height="84" loading="lazy">' : '') + '</span>' +
          '<div><div class="pals-cd__top"><div><span class="pals-cd__nm">' + esc(it.product_title) + (it.quantity > 1 ? ' \u00d7 ' + it.quantity : '') + '</span>' +
          '<div class="pals-cd__gift">Free gift with your ' + gift.with + '</div></div>' +
          '<div class="pals-cd__pr">' + (it.final_line_price === 0 ? '<b class="pals-cd__free">FREE</b>' : esc(money(it.final_line_price))) + was + '</div></div></div></div>';
      }
      var plan = spa && spa.selling_plan ? '<div class="pals-cd__plan"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 12a8 8 0 0113.7-5.6L20 8.7"/><path d="M20 4v4.7h-4.7"/><path d="M20 12a8 8 0 01-13.7 5.6L4 15.3"/><path d="M4 20v-4.7h4.7"/></svg>Subscription: ' + esc(spa.selling_plan.name) + '</div>' : '';
      // First delivery discounted (e.g. the 2-month intro): say what renews and when
      if (plan && it.final_line_price < spa.price * it.quantity) {
        var fq = (spa.selling_plan.name.match(/every\s+\d+\s+\w+|every\s+\w+/i) || [''])[0].toLowerCase();
        plan += '<div class="pals-cd__plan pals-cd__plan--n">' + esc(money(it.final_line_price)) + ' today, then ' + esc(money(spa.price * it.quantity)) + (fq ? ' ' + esc(fq) : ' each delivery') + '</div>';
      }
      // Halloween sale lines: the sale price in orange (discounts "Halloween sale: 30% off ...")
      var hw = (it.line_level_discount_allocations || []).some(function (a) { return /^halloween/i.test((a.discount_application && a.discount_application.title) || ''); });
      return '<div class="pals-cd__item" data-line="' + (i + 1) + '" data-key="' + esc(it.key) + '" data-qty="' + it.quantity + '">' +
        '<a class="pals-cd__img" href="' + esc(it.url) + '">' + (it.image ? '<img src="' + esc(sized(it.image, 200)) + '" alt="' + esc(it.product_title) + '" width="84" height="84" loading="lazy">' : '') + '</a>' +
        '<div><div class="pals-cd__top"><div><a class="pals-cd__nm" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
        (opts ? '<div class="pals-cd__var">' + opts + '</div>' : '') + (props ? '<div class="pals-cd__var">' + props + '</div>' : '') + plan + '</div>' +
        '<div class="pals-cd__pr">' + (hw ? '<span class="pals-cd__sale">' + esc(money(it.final_line_price)) + '</span>' : esc(money(it.final_line_price))) + was + '</div></div>' +
        '<div class="pals-cd__row"><div class="pals-cd__qty"><button type="button" data-pals-dec aria-label="Decrease quantity of ' + esc(it.product_title) + '">&minus;</button>' +
        '<span aria-label="Quantity">' + it.quantity + '</span><button type="button" data-pals-inc aria-label="Increase quantity of ' + esc(it.product_title) + '">+</button></div>' +
        '<button type="button" class="pals-cd__rm" data-pals-rm>Remove</button></div>' + inclHTML(it) + bundleNote(A, it) + '</div></div>';
    }
    list.innerHTML = cart.items.map(function (it, i) {
      var g = A && A.byLine[it._line];
      if (!g) return row(it, i);
      if (g.lines[0] !== it) return '';
      return '<div class="pals-cd__grp"><div class="pals-cd__grph"><span class="pals-cd__grpic" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M3 8l9-5 9 5-9 5z"/><path d="M3 8v8l9 5 9-5V8"/><path d="M12 13v8"/></svg></span>' +
        '<b>' + esc(g.title) + '</b><em>You save ' + esc(moneyR(g.save)) + '</em></div>' +
        g.lines.map(function (x) { return row(x, x._line - 1); }).join('') + '</div>';
    }).join('');
    if (offersEl) {
      var html = offersHTML(offers(A));
      offersEl.innerHTML = html;
      offersEl.hidden = !html;
    }
  }

  function showErr(msg) { if (!err) return; err.textContent = msg || ''; err.hidden = !msg; }

  function load() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { render(c); return c; });
  }

  function change(line, qty, row) {
    if (busy) return;
    busy = true;
    showErr('');
    if (row) row.classList.add(qty === 0 ? 'is-out' : 'is-busy');
    fetch('/cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: line, quantity: qty }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (c) { setTimeout(function () { render(c); busy = false; }, qty === 0 ? 240 : 0); })
      .catch(function (e) { busy = false; if (row) row.classList.remove('is-busy', 'is-out'); showErr((e && (e.description || e.message)) || 'Sorry, that change could not be made. Please try again.'); });
  }

  function trapFocus(e) {
    if (e.key !== 'Tab' || !root.classList.contains('is-open')) return;
    var f = panel.querySelectorAll('a[href], button:not([disabled]), input, [tabindex="0"]');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function open() {
    if (!root) { window.location.href = cfg.cartUrl; return; }
    lastFocus = document.activeElement;
    if (!list.children.length) list.innerHTML = '<div class="pals-cd__skel"></div><div class="pals-cd__skel"></div>';
    root.hidden = false;
    document.body.classList.add('pals-cd-lock');
    requestAnimationFrame(function () { requestAnimationFrame(function () { root.classList.add('is-open'); panel.focus({ preventScroll: true }); }); });
    load().catch(function () { window.location.href = cfg.cartUrl; });
  }
  function close() {
    if (!root || !root.classList.contains('is-open')) return;
    root.classList.remove('is-open');
    document.body.classList.remove('pals-cd-lock');
    setTimeout(function () { root.hidden = true; }, 380);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  function formError(form, msg) {
    var wrap = form.closest('product-info, .product__info-container, [data-pc]') || form.parentNode;
    var box = wrap && wrap.querySelector('.product-form__error-message-wrapper');
    if (box) {
      var t = box.querySelector('.product-form__error-message');
      if (t) t.textContent = msg;
      box.hidden = false;
      box.removeAttribute('hidden');
    } else {
      window.alert(msg);
    }
  }

  function add(form) {
    var btn = form.querySelector('[type="submit"]') || document.querySelector('button[form="' + form.getAttribute('id') + '"][type="submit"]');
    if (btn) { btn.setAttribute('aria-busy', 'true'); btn.classList.add('loading'); btn.disabled = true; }
    var wrap = form.closest('product-info, .product__info-container');
    var errBox = wrap && wrap.querySelector('.product-form__error-message-wrapper');
    if (errBox) errBox.hidden = true;
    // bundle picker on the product page: 'pair' = 2 of this item, 'addon' = this item + one more (data-pals-addon)
    var fd = new FormData(form);
    var mode = form.getAttribute('data-pals-mode');
    var sub = form.getAttribute('data-pals-sub');
    var extra = form.getAttribute('data-pals-extra');
    var body = fd;
    var headers = { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' };
    if (mode === 'addon' || mode === 'pair' || sub || extra) {
      var q = Math.max(1, parseInt(fd.get('quantity'), 10) || 1);
      var items = mode === 'pair'
        ? [{ id: +fd.get('id'), quantity: q * 2 }]
        : [{ id: +fd.get('id'), quantity: q }];
      if (mode === 'addon') items.push({ id: +form.getAttribute('data-pals-addon'), quantity: q });
      if (fd.get('selling_plan')) items[0].selling_plan = +fd.get('selling_plan');
      if (sub) {
        var sp = sub.split(':');
        // Fountain + filters bundle with the filter subscription ticked: the bundled pack becomes the subscription (no second pack)
        var same = mode === 'addon' && items.length > 1 && String(items[1].id) === String(sp[0]);
        if (same) items[1].selling_plan = +sp[1];
        else items.push({ id: +sp[0], quantity: 1, selling_plan: +sp[1] });
      }
      // extra filters ticked on the fountain page: one pack, on subscription when chosen
      if (extra) { var ex = extra.split(':'), xi = { id: +ex[0], quantity: 1 }; if (ex[1]) xi.selling_plan = +ex[1]; items.push(xi); }
      body = JSON.stringify({ items: items });
      headers['Content-Type'] = 'application/json';
    }
    return giftFirst(fd)
      .then(function () { return fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', body: body, headers: headers }); })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw j; return j; }); })
      .then(function () {
        if (onCartPage()) { window.location.reload(); return; }
        open();
      })
      .catch(function (e) { formError(form, (e && (e.description || e.message)) || 'Sorry, this item could not be added. Please try again.'); })
      .then(function () { if (btn) { btn.removeAttribute('aria-busy'); btn.classList.remove('loading'); btn.disabled = false; } });
  }

  // full cart page: keep the free kit in step after quantity changes there, then reload
  var giftT = null;
  function cartPageGift() {
    clearTimeout(giftT);
    giftT = setTimeout(function () {
      fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
        var need = giftNeed(c); if (need) fixGift(need).then(function () { window.location.reload(); }).catch(function () {});
      }).catch(function () {});
    }, 1500);
  }

  function boot() {
    if (onCartPage()) { cartPageGift(); document.addEventListener('change', cartPageGift); document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('cart-remove-button, .quantity__button')) cartPageGift(); }); }
    root = document.querySelector('[data-pals-cd]');
    if (root) {
      panel = root.querySelector('.pals-cd__panel');
      list = root.querySelector('[data-pals-cd-items]');
      offersEl = root.querySelector('[data-pals-cd-offers]');
      empty = root.querySelector('[data-pals-cd-empty]');
      foot = root.querySelector('[data-pals-cd-foot]');
      err = root.querySelector('[data-pals-cd-err]');
      shipBox = root.querySelector('[data-pals-cd-ship]');
      shipMsg = root.querySelector('[data-pals-cd-shipmsg]');
      shipLine = root.querySelector('[data-pals-cd-shipline]');
      bar = root.querySelector('[data-pals-cd-bar]');
      countEl = root.querySelector('[data-pals-cd-count]');
      subEl = root.querySelector('[data-pals-cd-sub]');
      discBox = root.querySelector('[data-pals-cd-disc]');
      discAmt = root.querySelector('[data-pals-cd-discamt]');
      cfg.money = root.getAttribute('data-money') || cfg.money;
      cfg.threshold = parseInt(root.getAttribute('data-threshold'), 10) || 0;
      cfg.cartUrl = root.getAttribute('data-cart-url') || '/cart';
      // keep the drawer outside the sticky header so it always covers the page
      if (root.parentNode !== document.body) document.body.appendChild(root);
      // filter offer: "No subscription" turns the Subscribe button into Add to cart and hides the subscription small print
      root.addEventListener('change', function (e) {
        if (!e.target || e.target.name !== 'pals-bo-sub') return;
        var box = e.target.closest('.pals-bo'); if (!box) return;
        var one = !e.target.value, b = box.querySelector('[data-pals-offer="sub"]'), fine = box.querySelector('[data-pals-sub-fine]');
        if (b) b.textContent = one ? 'Add to cart' : 'Subscribe';
        var t = box.querySelector('.pals-bo__t');
        if (t) { if (!t.hasAttribute('data-orig')) t.setAttribute('data-orig', t.innerHTML); t.innerHTML = one ? 'Add replacement filters' : t.getAttribute('data-orig'); }
        if (fine) fine.hidden = one;
      });
      root.addEventListener('click', function (e) {
        if (e.target.closest('[data-pals-cd-close]')) { close(); return; }
        var wb = e.target.closest('[data-pals-war-add]');
        if (wb) {
          var wbox = wb.closest('[data-pals-cd-war]');
          wb.disabled = true; wb.setAttribute('aria-busy', 'true'); showErr('');
          post('/cart/add.js', { items: [{ id: +wbox.getAttribute('data-variant'), quantity: +wb.getAttribute('data-need') || 1 }] })
            .then(function () { return load(); })
            .catch(function (er) { showErr((er && (er.description || er.message)) || 'Sorry, that could not be added. Please try again.'); })
            .then(function () { wb.disabled = false; wb.removeAttribute('aria-busy'); });
          return;
        }
        var ob = e.target.closest('[data-pals-offer]');
        if (ob) { takeOffer(ob).then(function () { return load(); }).catch(function () {}); return; }
        var row = e.target.closest('.pals-cd__item');
        if (!row) return;
        var line = +row.getAttribute('data-line'), q = +row.getAttribute('data-qty');
        if (e.target.closest('[data-pals-inc]')) change(line, q + 1, row);
        else if (e.target.closest('[data-pals-dec]')) change(line, Math.max(0, q - 1), row);
        else if (e.target.closest('[data-pals-rm]')) change(line, 0, row);
      });
    }
  }

  // cart icon opens the drawer (the full cart page still works on /cart and with ctrl/cmd-click)
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-pals-cart-open]');
    if (!t || onCartPage() || !root || e.metaKey || e.ctrlKey || e.shiftKey) return;
    e.preventDefault();
    open();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); trapFocus(e); });

  // every add-to-cart form (product page, sticky bar, product cards) adds in place and opens the drawer
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action || !/\/cart\/add/.test(form.action) || !window.fetch || !window.FormData) return;
    if (form.hasAttribute('data-pals-native')) return;
    if (!root) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    add(form);
  }, true);

  window.PalsCart = { open: open, close: close, refresh: load, add: add, bundles: { analyse: analyse, offers: offers, offersHTML: offersHTML, takeOffer: takeOffer, noteText: noteText, money: function (c) { return money(c); }, moneyR: function (c) { return moneyR(c); }, esc: esc } };
  document.addEventListener('pals:shipcountry', function () { if (root && typeof load === 'function') load(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();